import { Outlet } from '@tanstack/react-router';

export function RootLayout() {
  return <Outlet />;
}
